import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { HiX } from "react-icons/hi";

const Sidebar = ({ isOpen, onClose, side, children }) => {
  const sidebarVariants = {
    open: {
      x: 0,
      transition: { type: "spring", stiffness: 300, damping: 30 },
    },
    closed: {
      x: side === "left" ? "-100%" : "100%",
      transition: { type: "spring", stiffness: 300, damping: 30 },
    },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-50"
            onClick={onClose}
          />
          <motion.div
            className={`fixed top-0 ${
              side === "left" ? "left-0" : "right-0"
            } h-full bg-white w-[85vw] max-w-sm z-50 shadow-lg`}
            variants={sidebarVariants}
            initial="closed"
            animate="open"
            exit="closed"
          >
            <div className="flex justify-end p-2">
              <button
                onClick={onClose}
                className="p-2 text-gray-500 hover:text-gray-800"
                aria-label="Close menu"
              >
                <HiX className="w-6 h-6" />
              </button>
            </div>
            <div className="overflow-y-auto h-[calc(100%-48px)] pb-10">
              {children}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Sidebar;
